<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingUitkeringen">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseUitkeringen" aria-expanded="false" aria-controls="collapseUitkeringen">
                Periodieke uitkeringen
            </button>
        </h2>
        <div id="collapseUitkeringen" class="accordion-collapse collapse" aria-labelledby="headingUitkeringen"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Bij periodieke uitkeringen (zoals alimentatie, studietoelagen of lijfrente-uitkeringen uit een
                privéschenking) kan sprake zijn van een schenking als de betalingen niet op een wettelijke of
                contractuele verplichting berusten. De schenkbelasting wordt dan geheven over de contante waarde van de
                toekomstige betalingen, berekend volgens actuariële rekenregels. Dit geldt niet voor
                alimentatieverplichtingen opgelegd door de rechter.
                <div class="space20"></div>
                Het is essentieel om het onderscheid tussen verplicht en vrijwillig karakter goed te documenteren.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingUitkeringsfrequentie">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseUitkeringsfrequentie" aria-expanded="false"
                    aria-controls="collapseUitkeringsfrequentie">
                Periode van de uitkeringen
            </button>
        </h2>
        <div id="collapseUitkeringsfrequentie" class="accordion-collapse collapse"
             aria-labelledby="headingUitkeringsfrequentie"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Bij een schenking in de vorm van periodieke uitkeringen of verstrekkingen kan gekozen worden voor een
                bepaalde uitkeringsfrequentie. De gebruikelijke perioden zijn:
                <ul>
                    <li><strong>Jaarlijks</strong> – één uitkering per jaar</li>
                    <li><strong>Per kwartaal</strong> – vier uitkeringen per jaar</li>
                    <li><strong>Maandelijks</strong> – twaalf uitkeringen per jaar</li>
                    <li><strong>Wekelijks</strong> – 52 uitkeringen per jaar</li>
                </ul>
                De frequentie van uitkeren beïnvloedt de belastingheffing niet direct, maar is wel van belang voor de
                vastlegging en uitvoering van de schenkingsovereenkomst.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingEindeUitkering">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseEindeUitkering" aria-expanded="false"
                    aria-controls="collapseEindeUitkering">
                Einde van de uitkeringen bij overlijden
            </button>
        </h2>
        <div id="collapseEindeUitkering" class="accordion-collapse collapse" aria-labelledby="headingEindeUitkering"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Of de uitkeringen stoppen bij overlijden van de schenker of begiftigde hangt af van de afspraken in de
                schenkingsovereenkomst:
                <ul>
                    <li><strong>Levenslange uitkering:</strong> eindigt bij overlijden van de begiftigde of schenker,
                        afhankelijk van wat is overeengekomen.
                    </li>
                    <li><strong>Tijdelijke uitkering:</strong> loopt door tot het einde van de afgesproken termijn,
                        tenzij expliciet bepaald dat het overlijden eerder beëindigt.
                    </li>
                </ul>
                <em>Belangrijk:</em> bij overlijden vóór afloop van de termijn kunnen er fiscale gevolgen zijn, zoals
                herrekening van schenkbelasting of gevolgen voor de erfbelasting.
            </div>
        </div>
    </div>

</div>
